import {
  ExportParamsRequest,
  ParamsRequest,
} from 'Services/__shared/types/resquest'

const QueryStringFilter = (
  url: string,
  filter?: any,
  params?: ParamsRequest | ExportParamsRequest,
): string => {
  let obj: any
  if (filter) {
    obj = filter
  }

  if (params) {
    obj = {
      ...obj,
      ...params,
    }
  }

  if (obj) {
    let i = 0
    return (
      url +
      Object.keys(obj).reduce((str, key) => {
        const delimiter = i === 0 ? '?' : '&'
        const keyAux = encodeURIComponent(key)
        const val =
          obj[keyAux] !== undefined && obj[keyAux] !== null
            ? encodeURIComponent(obj[keyAux])
            : undefined
        if (val !== undefined && val !== '') {
          i += 1
          return [str, delimiter, keyAux, '=', val].join('')
        } else {
          return [str].join('')
        }
      }, '')
    )
  } else {
    return url
  }
}

export default QueryStringFilter
